import { useId } from "react";
import { IsoDateInput } from "@/features/invoices/components/IsoDateInput";
import { startOfLocalToday } from "@/utils/format/isoDate";

interface DateRangeFilterProps {
  label?: string;
  dateFrom: string;
  dateTo: string;
  onChange: (patch: { dateFrom?: string; dateTo?: string }) => void;
  /** Cap both ends at today (for created-date filters). */
  disableFuture?: boolean;
}

export function DateRangeFilter({
  label = "Date range",
  dateFrom,
  dateTo,
  onChange,
  disableFuture = false,
}: DateRangeFilterProps) {
  const baseId = useId();
  const maxDate = disableFuture ? startOfLocalToday() : undefined;

  return (
    <div className="filter-dates min-w-0">
      <span className="filter-dates-label mb-1 block text-[0.72rem] font-semibold text-[var(--muted)]">
        {label}
      </span>
      <div
        className="filter-dates-inputs grid items-center gap-1.5"
        role="group"
        aria-label="Date range"
      >
        <div className="filter-date-field min-w-0 flex-1">
          <IsoDateInput
            id={`${baseId}-from`}
            value={dateFrom}
            onChange={(dateFrom) => onChange({ dateFrom })}
            aria-label="From date (YYYY-MM-DD)"
            maxDate={maxDate}
          />
        </div>
        <span
          className="filter-dates-sep text-center text-sm font-semibold text-[var(--muted)]"
          aria-hidden
        >
          –
        </span>
        <div className="filter-date-field min-w-0 flex-1">
          <IsoDateInput
            id={`${baseId}-to`}
            value={dateTo}
            onChange={(dateTo) => onChange({ dateTo })}
            aria-label="To date (YYYY-MM-DD)"
            maxDate={maxDate}
          />
        </div>
      </div>
    </div>
  );
}
